{
  "reportingConfiguration": {
    "title": "Configurazione dei report",
    "information": "A intervalli regolari un report sarà trasmesso ai contatti configurati qui sotto.",
    "frequency": "Periodicità del report (in giorni)",
    "time": "Ora del report"
  },
  "recipients": {
    "title": "Destinatari",
    "users": {
      "empty": "Nessun destinatario",
      "select": {
        "label": "Aggiungere dei destinatari"
      },
      "add": {
        "label": "Aggiungere dei destinatari",
        "notification": {
          "success": "I seguenti destinatari sono stati aggiunti"
        }
      },
      "remove": {
        "label": "Rimuovere i destinatari selezionati",
        "confirm": {
          "title": "Rimuovere i destinatari",
          "message": "I seguenti destinatari saranno rimossi:"
        },
        "notification": {
          "success": "I seguenti destinatari sono stati rimossi"
        }
      }
    }
  },
  "validation": {
    "frequency": {
      "required": "La periodicità del report è obbligatoria"
    },
    "time": {
      "required": "L’ora del report è obbligatoria"
    }
  }
}
